import { LabelWithUnit } from 'components/secondaryMarket/shared/Label';
import { useAutoRefreshedValue } from 'hooks/useAutoRefreshValue';
import { useSPIntl } from 'hooks/useIntl';
import type { BootstrapColor } from 'models/BootstrapVars';
import { CutOffType } from 'models/cutOff';
import { FC, useCallback } from 'react';
import { now } from 'utils/core/now';

import type { CutOffStatus } from './cutoffStatus';
import { getCutOffStatus } from './cutoffStatus';

function getColor(status: CutOffStatus): BootstrapColor | undefined {
  switch (status) {
    case 'Missed':
      return 'danger';
    case 'Urgent':
      return 'warning';
    default:
      return undefined;
  }
}

export function useCutoffStatus(nextCutOff: Date | undefined) {
  const refreshStatus: () => CutOffStatus = useCallback(() => getCutOffStatus(nextCutOff, now()), [nextCutOff]);
  return useAutoRefreshedValue(refreshStatus, 1_000);
}

export const RefreshedCutOffInfos: FC<CutOffType> = ({ cutOffZoneId, nextCutOff }) => {
  const status = useCutoffStatus(nextCutOff);
  const { formatTime } = useSPIntl();
  return (
    <CutOffInfos
      cutOffTime={formatTime(nextCutOff, cutOffZoneId ? { timeZone: cutOffZoneId } : undefined)}
      cutOffZoneId={cutOffZoneId}
      status={status}
    />
  );
};

export const CutOffInfos: FC<
  Omit<CutOffType, 'nextCutOff'> & {
    status?: CutOffStatus;
  }
> = ({ cutOffTime, cutOffZoneId, status }) => (
  <LabelWithUnit
    id="CutOffTime"
    value={cutOffTime}
    unit={cutOffZoneId ?? ''}
    e2e="cutoff-time"
    color={getColor(status)}
  />
);
